<script setup lang="ts">
import { vIntersectionObserver } from "@vueuse/components";
import { computed } from "vue";
import { useAnalyticManager } from "@magnit/analytic-events";
import VText from "@magnit/core/src/components/VText/VText.vue";
import OkLogo from "./assets/svg/socials/ok.svg";
import VkLogo from "./assets/svg/socials/vk.svg";
import TelegramLogo from "./assets/svg/socials/telegram.svg";
import type {
  IFooterSocial,
  IFooterSocialNames,
  IFooterSocialsLinks,
} from "./footer.types";

const props = defineProps<{ links: IFooterSocialsLinks }>();

const { send } = useAnalyticManager();

const sendItemView = (element: IFooterSocialNames) => {
  send("Footer:Socials:View", {
    element: element.toLowerCase(),
  });
};
const onVisibility = (
  element: IFooterSocialNames,
  [{ isIntersecting }]: IntersectionObserverEntry[],
) => {
  if (isIntersecting) {
    sendItemView(element);
  }
};

const allItems = computed<IFooterSocial[]>(() => [
  {
    name: "Vk",
    url: props.links.vk,
    logo: VkLogo,
  },
  {
    name: "Tg",
    url: props.links.tg,
    logo: TelegramLogo,
  },
  {
    name: "Ok",
    url: props.links.ok,
    logo: OkLogo,
  },
]);

const items = computed(() => allItems.value.filter((item) => item.url));
</script>

<template>
  <div class="unit-footer-socials">
    <VText
      tag="h4"
      :font="{ xs: 'title-medium', ml: 'title-small' }"
      class="unit-footer-socials__title"
      >Наши соцсети</VText
    >
    <div class="unit-footer-socials__links">
      <a
        v-for="item in items"
        :key="item.name"
        v-intersection-observer="
          (io: IntersectionObserverEntry[]) => onVisibility(item.name, io)
        "
        :href="item.url"
        rel="noreferrer"
        target="_blank"
        :aria-label="item.name"
        @click="send(`Footer:Socials:${item.name}:Click`)"
      >
        <component :is="item.logo" />
      </a>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.unit-footer-socials {
  &__title {
    margin-bottom: var(--pl-unit-x3);
  }

  &__links {
    display: flex;
    flex-flow: row wrap;
    gap: var(--pl-unit-x2);

    & a {
      display: inline-flex;
    }
  }
}

@media (--pl-viewport-from-ml) {
  .unit-footer-socials {
    &__links {
      svg {
        height: 40px;
        width: 40px;
      }
    }
  }
}
</style>
